import { z } from 'zod';

import { ParticipantZod } from 'types/zod/participant';

export const SummaryParticipantZod = ParticipantZod.and(
    z.object({
        roles: z.array(z.string()),

        contactOption: z.union([z.literal('email'), z.literal('phone'), z.literal('emailAndPhone')]).optional(),
    }),
);
export type SummaryParticipant = z.infer<typeof SummaryParticipantZod>;
